import { render, staticRenderFns } from "./SharedAnchorPage.vue?vue&type=template&id=72c9686e&scoped=true"
import script from "./SharedAnchorPage.vue?vue&type=script&lang=js"
export * from "./SharedAnchorPage.vue?vue&type=script&lang=js"
import style0 from "./SharedAnchorPage.vue?vue&type=style&index=0&id=72c9686e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c9686e",
  null
  
)

export default component.exports